import gsap from "gsap";
import { MotionPathPlugin, ScrollTrigger } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

export default class ScrollTriggerReady extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			wrap: selector(".scroll-trigger-ready__worm-wrap"),
			balls: selector(".scroll-trigger-ready__ball"),
			wormholes: selector(".scroll-trigger-ready__wormhole"),
			path: selector("#worm-path path"),
		};
		this.DOM = DOM;

		this.defaults = {
			ease: "power2.out",
			duration: 0.4,
		};

		this.tl = this.createTimeline();
	}

	ball(ball) {
		const tl = gsap.timeline({
			defaults: this.defaults,
		});

		tl.to(this.DOM.wormholes[0], {
			scale: 1,
			repeat: 1,
			yoyo: true,
			yoyoEase: "power2.in",
			clearProps: true,
		});

		tl.set(
			ball,
			{
				autoAlpha: 1,
			},
			0.2
		);

		tl.to(
			ball,
			{
				motionPath: {
					path: this.DOM.path[0],
					align: this.DOM.path[0],
					alignOrigin: [0.5, 0.5],
					start: 0.5,
				},
				ease: "none",
				duration: 4,
			},
			0.2
		);

		tl.to(
			this.DOM.wormholes[1],
			{
				scale: 1,
				repeat: 1,
				yoyo: true,
				yoyoEase: "power2.in",
				clearProps: true,
			},
			"-=.4"
		);

		return tl;
	}

	createTimeline() {
		const tl = gsap.timeline({
			id: "scroll-balls",
			defaults: this.defaults,
			scrollTrigger: {
				invalidateOnRefresh: true,
				scrub: 1,
				trigger: this.DOM.wrap,
				start: "top 90%",
				end: "bottom 30%",
			},
		});

		tl.set(this.DOM.wrap, { autoAlpha: 1 });

		const mm = gsap.matchMedia();

		watchPreferredMotion(() => {
			/* Animate */

			tl.add(this.ball(this.DOM.balls[0]));
			tl.add(this.ball(this.DOM.balls[1]), 2);
		});

		return tl;
	}
}
